import { ELSIconV2 } from 'components/common';
import { RoutePath } from 'constants/app.constant';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { useHistory } from 'react-router-dom';
var InternalBackButton = function () {
    var history = useHistory();
    var handleBackClick = function () {
        if (history.length > 1) {
            history.goBack();
        }
        else {
            history.push(RoutePath.home);
        }
    };
    return (<div role="button" className="u-cursor-pointer u-els-color-secondary" onClick={handleBackClick} onKeyDown={function (e) { return onKeyDownHandler(e, handleBackClick); }} tabIndex={0}>
      <ELSIconV2 sprite="ArrowLeft" size="xs"/>
      <span className="u-els-font-size-meta u-els-margin-left-3o4">Back</span>
    </div>);
};
export default InternalBackButton;
